import React, { useRef } from 'react'
import { ArrowGenerator } from './arrowGenerator'
import browserCheck from '@ta-interaktiv/browsercheck'
let isMobile = browserCheck.isMobile
let device =  'desktop'
const percentToPixel = (convert: number, hundred: number) => {
  let val = (convert * hundred) / 100
  return isNaN(val) ? 0 : val
}

const countToSwitchToLines = 1000000
export const OffsetAnnotation = ({
  position,
  content,
  svgSize = [0, 0],
  offset = [0, 0],
  alignOverwrite,
  Comp,
  lineHeight,
  linePadding,
  hideArrow,
  lineType = 'flows',
  marker
}: OffsetAnnotation) => {
  let x = percentToPixel(content[device].position[0], svgSize[0])
  let y = percentToPixel(content[device].position[1], svgSize[1])
  let offX = percentToPixel(content[device].offset[0], svgSize[0])
  let offY = percentToPixel(content[device].offset[1], svgSize[1])
  if (x === 0 || y === 0) return null

  let align = 'start'
  if (x >= x + offX) align = 'end'
  if (content[device].align !== '') align = content[device].align

  let pathString = ArrowGenerator(
    { x: -offX, y: -offY },
    svgSize,
    linePadding || 0,
    lineHeight,
    lineType
  )
  let scaleMobile = 0.008
  let scaleDesktop = 0.0025

  let biggerCountriesDashArray = '1'
  let rad = Math.sqrt(+content.cases / Math.PI) * scaleDesktop + 'vmax'

  let rad2 = Math.sqrt(+content.death / Math.PI) * scaleDesktop + 'vmax'

  type lineCapType = 'round' | 'butt' | 'square' | 'inherit' | undefined
  let styleChinaCases = {
    fillOpacity: 0,
    strokeDasharray: biggerCountriesDashArray,
    strokeLinecap: 'round' as lineCapType,
    strokeOpacity: 0.6,
    strokeWidth: 3,
    stroke: '#FFE462'
  }
  let styleChinaDeath = {
    fillOpacity: 1,
    strokeDasharray: biggerCountriesDashArray,
    strokeLinecap: 'round' as lineCapType,
    strokeOpacity: 0.4,
    strokeWidth: 2
  }
  let noOpacity = { opacity: 1, fillOpacity: 1 }
  return (
    <g transform={'translate(' + x + ',' + y + ')'} className={content.de}>
      {content.de && (
        <>
          {content.de && (
            <circle
              cx={0}
              cy={0}
              r={rad}
              fill='none'
              // stroke='#fff'
              // strokeWidth={2}
              strokeOpacity={1}
            />
          )}

          <circle
            cx={0}
            cy={0}
            r={rad}
            fill='#FFE462'
            fillOpacity={0.6}
            stroke='#fff'
            strokeWidth={1}
            // {...(content.cases < 100 ? noOpacity : {})}
            // {...(content.cases > countToSwitchToLines ? styleChinaCases : {})}
          />

          <circle
            cx={0}
            cy={0}
            r={rad2}
            fill='#d3343f'
            fillOpacity={0.6}
            // stroke='#c4354a'
            strokeOpacity={0.8}
            strokeWidth={0.75}
            // {...(content.de === 'China' ? styleChinaDeath : {})}
          />
        </>
      )}
      {content[device].annotate !== '0' && content[device].annotate !== '' && (
        <>
          {' '}
          <g
            transform={'translate(' + offX + ',' + offY + ') scale(' + 1 + ')'}
          >
            <Comp content={content} align={align} lineHeight={lineHeight} />
          </g>
          <g transform={'translate(' + offX + ',' + offY + ')'}>
            {(+offX !== 0 || +offY !== 0) && (
              <path
                d={pathString}
                className='arrow'
                fill='none'
                markerEnd={
                  !hideArrow ? marker && 'url(#' + marker[1] + ')' : undefined
                }
                markerStart={
                  !hideArrow ? marker && 'url(#' + marker[0] + ')' : undefined
                }
              />
            )}
          </g>
        </>
      )}
    </g>
  )
}
